import {
  FormEvent,
  useState,
} from 'react';

import {
  Link,
  useLocation,
} from 'react-router-dom';

import { authApi } from '../../api/authApi';
import { getApiErrorMessage } from '../../api/apiClient';
import Spinner from '../../components/Spinner';
import { useAuth } from '../../context/AuthContext';
import AuthPageShell from './AuthPageShell';

export default function ForgotPasswordPage() {
  const location = useLocation();

  const locationState = location.state as
    | { email?: string }
    | null;

  const [email, setEmail] = useState(
    locationState?.email ?? ''
  );

  const [loading, setLoading] =
    useState(false);

  const [message, setMessage] =
    useState('');

  const [error, setError] =
    useState('');

  const { claims } = useAuth();

  async function handleSubmit(
    event: FormEvent
  ) {
    event.preventDefault();

    setLoading(true);
    setError('');

    try {
      await authApi.forgotPassword({
        email,
        brandingId: claims?.brandingId,
      });

      setMessage(
        'If an account exists for this email, reset instructions have been sent.'
      );
    } catch (requestError) {
      setError(
        getApiErrorMessage(
          requestError,
          'Unable to request a password reset.'
        )
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthPageShell title="Reset your password">
      {message ? (
        <div className="space-y-6 text-center">
          <h2 className="text-xl font-bold text-strivre-navy">
            Check Your Email
          </h2>

          <p className="text-slate-500">
            If an account exists for this email address,
            a password reset link has been sent.
          </p>

          <Link
            className="btn-secondary block w-full py-3 text-center"
            to="/login"
          >
            Back to Login
          </Link>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <label
            className="block text-sm font-semibold text-slate-700"
            htmlFor="email"
          >
            Email address

            <input
              id="email"
              required
              type="email"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              className="input-base mt-1 w-full"
              placeholder="name@company.com"
            />
          </label>

          {error && (
            <p className="text-sm text-red-600">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="btn-primary flex w-full justify-center py-3"
            disabled={loading}
          >
            {loading ? (
              <Spinner size="h-5 w-5" />
            ) : (
              'Send reset link'
            )}
          </button>

          <Link
            className="block text-center text-sm font-semibold text-strivre-burgundy"
            to="/login"
          >
            Back to Login
          </Link>
        </form>
      )}
    </AuthPageShell>
  );
}